import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Encode Sans', sans-serif;
  font-size: 30px;
  height: 47px;
`;
Container.displayName = 'Container';

export const Logo = styled.img`
  height: 60px;
  margin: 0 8px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  font-size: 34px;
  font-weight: 600;
  line-height: 41px;
  min-width: 45px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #021c44;
  color: #d0fb0c;
  display: flex;
  font-weight: bold;
  justify-content: center;
  min-width: 155px;
  padding: 0 16px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  padding: 0 12px;
`;
Space.displayName = 'Space';

export const TeamName = styled.div`
  align-items: center;
  background-color: #021c44;
  color: #fff;
  display: flex;
  font-size: 22px;
  font-weight: 300;
  line-height: 25px;
  justify-content: center;
  min-width: 135px;
  padding: 0 16px;
  text-align: center;
`;
TeamName.displayName = 'TeamName';

export const Timer = styled.div`
  align-items: center;
  background-color: #d0fb0c;
  color: #021c44;
  display: flex;
  font-weight: 600;
  justify-content: center;
  min-width: 126px;
  padding: 0 16px;
  text-align: center;
`;
Timer.displayName = 'Timer';
